import angular from 'angular';
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import '../core.module';

class EventBusService {
  constructor() {
    this.events$ = new Subject();
  }

  emit(eventName, payload) {
    this.events$.next({ eventName, payload });
  }

  on(eventName) {
    return this.events$.asObservable().pipe(
      filter((event) => event.eventName === eventName),
      map((event) => event.payload)
    );
  }
}

angular.module('app.core').service('EventBusService', EventBusService);

export default EventBusService;
